import { ReactNode, useEffect } from "react";
import { Sparkles } from "lucide-react";
import { dictionary, Language } from "@/utils/dictionary";
import { useAuth } from "@/context/AuthContext";
import { DefaultButton } from "@/components/buttons/DefaultButton";
import { CreditsBadge } from "@/components/ui/badge/CreditBadge";
import { membershipAxios } from "@/services/membership/MembershipAxios";

interface AdsCreativesHeaderProps {
  onCreate?: () => void;
  creativesCount?: number;
  rightContent?: ReactNode;
}

export function AdsCreativesHeader({ onCreate, creativesCount, rightContent }: AdsCreativesHeaderProps) {
  const { language, credits, setCredits } = useAuth();

  useEffect(() => {
    membershipAxios()
      .then((membership) => setCredits(membership.credits || 0))
      .catch(() => {});
  }, []);

  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between mb-4">
      {/* Left: title + subtitle */}
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-xl bg-white flex items-center justify-center shadow-sm border border-gray-100">
          <Sparkles className="h-5 w-5 text-indigo-600" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900 leading-tight">
            {dictionary["your-ads"]?.[language as Language] || "Tus Anuncios"}
          </h1>
          <p className="text-sm text-gray-500 mt-0.5">
            {creativesCount != null && creativesCount > 0
              ? `${creativesCount} anuncios creados`
              : (dictionary["select-a-product-to-create-ads"]?.[language as Language] ||
                "Selecciona un producto para crear anuncios")}
          </p>
        </div>
      </div>

      {/* Right: slot for tab-specific actions */}
      {rightContent !== undefined ? rightContent : (
        <div className="flex items-center gap-3">
          <CreditsBadge amount={credits} label={dictionary["credits"]?.[language as Language]} />
          <DefaultButton
            title={
              dictionary["create-new-ad-with-ai"]?.[language as Language] ||
              "Crear nuevo Anuncio con IA"
            }
            onClick={onCreate ?? (() => console.log("crear nuevo anuncio con IA"))}
            icon={<Sparkles className="h-4 w-4" />}
            className="w-full md:w-auto font-semibold"
          />
        </div>
      )}
    </div>
  );
}
